import SelectorEngine from '../../../utils/dom/selector-engine';
import { Events } from '../../../utils/dom/html-events';
import { ClassNames } from '../../../utils/dom/css-classes';
import Request, { ApiMode } from '../../../utils/request';
import EventHandler from '../../../utils/dom/event-handler';
import FormGenerator, { FormTypes } from '../../../components/FormGenerator';
import Modal from '../../../../client/components/Modal';
import Manipulator from '../../../utils/dom/manipulator';

const SELECTOR_WRAPPER = '.p-accreditation-renewal-review';
const SELECTOR_MODAL = '.js-accreditation-renewal-review-modal';

const SELECTOR_SPLASH = '.p-accreditation-renewal-review-splash';
const SELECTOR_SPLASH_NEXT = '.p-accreditation-renewal-review-splash-next';

const SELECTOR_STEP = '.p-accreditation-renewal-review-step';
const SELECTOR_QUESTION = '.p-accreditation-renewal-review-questions';

const SELECTOR_EXIT_BUTTON = '.js-exit-accreditation-renewal-review';
const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-accreditation-renewal-review-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-accreditation-renewal-review-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-accreditation-renewal-review-confirm-no';

const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';

class AccreditationRenewalReview {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modal = new Modal(this.modalElement, { backdrop: 'static' });
		this.modal.show();

		this.splash = SelectorEngine.findOne(SELECTOR_SPLASH, this._wrapper);
		this.splashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.splash);

		this.step = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.questions = SelectorEngine.findOne(SELECTOR_QUESTION, this.step);

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);
		this.redirectUrl = Manipulator.getDataAttribute(this._wrapper, 'redirect-url');

		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.splashNext, Events.Click, () => {
			this.fetchSteps();
		});
		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	async fetchSteps() {
		try {
			// TODO CSA: this endpoint has not been confirmed yet
			const url = '/api/coachdetails/getaccreditationreviewform';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error : ', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.splash.classList.add(ClassNames.Hidden);
		this.step.classList.remove(ClassNames.Hidden);

		this.formGenerator = new FormGenerator(this.questions, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			radioAnswerField: 'id',
			isBackButtonEnabled: true,
			isHideProgress: false,
			mainPageElement: this.step,
			stepVisibility: [false],
			backButtonHandlerFirstStep: () => {
				this.splash.classList.remove(ClassNames.Hidden);
				this.step.classList.add(ClassNames.Hidden);
			}
		});

		this.formGenerator.onChange((answers) => {
			this.saveData({
				satisfictionLevel: this.getAnswerByFieldName(answers, 'satisfictionLevel', 'label'),
				additionalComments: this.getAnswerByFieldName(answers, 'additionalComments')
			})
		});

		this.formGenerator.onStepChange(() => {
			this.step.scrollTop = 0;
		});
	}

	async saveData(payload) {
		console.log(payload);
		try {
			let url = '/api/myaccreditationDetails/updatereview';
			const apiResponse = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { success } = apiResponse;
			if(success) {
				window.location.href = this.redirectUrl;
			}
		} catch(error) {
			console.error(error);
		}
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}

	getAnswerByFieldName(answers, filedName, option) {
		const question = this.formGenerator.questions.find(question => question?.[KEY_OBJECT] === filedName);
		if(question) {
			if(option) {
				return answers?.[question.step]?.[question?.id]?.label;
			}
			return answers?.[question.step]?.[question?.id]?.value;
		}
		return null;
	}
}

const globalAccreditationRenewalReview = new AccreditationRenewalReview();
export default globalAccreditationRenewalReview;
